import { render, staticRenderFns } from "./SCR_MBC_0115_03.vue?vue&type=template&id=5e2de142&scoped=true&"
import script from "./SCR_MBC_0115_03.vue?vue&type=script&lang=js&"
export * from "./SCR_MBC_0115_03.vue?vue&type=script&lang=js&"
import style0 from "./SCR_MBC_0115_03.vue?vue&type=style&index=0&id=5e2de142&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2de142",
  null
  
)

export default component.exports